<template>
  <Card v-if="loaded">
    <p slot="title">Правил приема</p>
    <Form
      ref="form"
      :model="model"
      :rules="rules"
    >
      <FormItem label="Правила приема" prop="rules">
        <Input
          type="textarea"
          autosize
          v-model="model.rules"
        />
      </FormItem>
      <Button
        type="primary"
        long
        :loading="saving"
        v-on:click="handleSave"
      >
        Сохранить
      </Button>
    </Form>
  </Card>
  <Spin v-else size="large" fix/>
</template>

<script>
import firebase from 'firebase/app';
import 'firebase/database';
import 'firebase/auth';

export default {
  data() {
    return {
      id: null,
      loaded: false,
      saving: false,
      model: {
        rules: null
      },
      rules: {
        rules: [{ required: true, message: ' ', pattern: /([^\s])/ }]
      }
    }
  },
  async mounted() {
    const email = firebase.auth().currentUser.email;

    const ref = firebase.database().ref(`institutions`)
    .orderByChild('admin').equalTo(email);
    const snapshot = await ref.once('value');
    const array = [];
    
    snapshot.forEach(childSnapshot => {
      const element = childSnapshot.val();
      element.id = childSnapshot.key;
      array.push(element);
    });

    if(array.length > 0) {
      const institution = array[0];

      if(!institution.active) {
        await firebase.auth().signOut();

        this.$router.push('/auth');
      }

      this.id = institution.id;
      this.model = {
        rules: institution.rules
      };
    }

    this.loaded = true;
  },
  methods: {
    async handleSave() {
      const valid = await new Promise(
        resolve => this.$refs.form.validate(valid => resolve(valid))
      );

      if(!valid) {
        this.$Message.error("Необходимо заполнить поля");
        return;
      }

      await this.save();
    },
    async save() {
      this.saving = true;

      try {
        const ref = firebase.database().ref(`institutions/${this.id}`);

        await ref.update(this.model);

        this.$Message.success("Успешно сохранено");

        this.saving = false;
      }
      catch(error) {
        console.log(error);
        
        this.$Message.error("Ошибка");

        this.saving = false;
      }
    }
  }
}
</script>

<style scoped>

</style>